<div class="last-update-container">

    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <g clip-path="url(#clip0_2714_385574)">
        <path d="M4.375 14.375L1.875 11.875L4.375 9.375" stroke="#433E3F" stroke-width="1.35998" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.125 8.125V9.375C13.125 10.038 12.8616 10.6739 12.3928 11.1428C11.9239 11.6116 11.288 11.875 10.625 11.875H1.875" stroke="#433E3F" stroke-width="1.35998" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.625 0.625L13.125 3.125L10.625 5.625" stroke="#433E3F" stroke-width="1.35998" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.875 6.875V5.625C1.875 4.96196 2.13839 4.32607 2.60723 3.85723C3.07607 3.38839 3.71196 3.125 4.375 3.125H13.125" stroke="#433E3F" stroke-width="1.35998" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_2714_385574">
        <rect width="15" height="15" fill="white"/>
        </clipPath>
        </defs>
    </svg>

    <span class="text" *ngIf="(hasLastUpdateError$ | async) === true">Ocurrió un problema, reintente.</span>
    <span class="text" *ngIf="(hasLastUpdateError$ | async) !== true && (lastUpdate$ | async) != null">Última actualización: {{ (lastUpdate$ | async) | date:'dd/MM/yyyy HH:mm:ss' }}</span>
    <span class="text" *ngIf="(hasLastUpdateError$ | async) !== true && (lastUpdate$ | async) == null">Cargando valores...</span>

</div>